const LOCAL_STORAGE_TEST_KEY = '__ONESIGNAL_SHOPIFY__';

export default class LocalStorage {
  /**
   * Local in memory cache if localstorage is supported.
   */
  private static _isSupported: boolean|undefined;

  /**
   * Tests if localstorage is available and caches the result.
   */
  private static isSupported(): boolean {
    if (typeof this._isSupported !== "undefined") {
      return this._isSupported;
    }

    if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
      this._isSupported = false;
      return this._isSupported;
    }

    try {
      window.localStorage.setItem(LOCAL_STORAGE_TEST_KEY, LOCAL_STORAGE_TEST_KEY);
      window.localStorage.removeItem(LOCAL_STORAGE_TEST_KEY);
      this._isSupported = true;
    } catch (e) {
      this._isSupported = false;
    }

    return this._isSupported;
  }

  public static set(key: string, value: string): void {
    if (!this.isSupported()) {
      return;
    }

    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      return;
    }
  }

  public static get(key: string): string|null {
    if (!this.isSupported()) {
      return null;
    }

    try {
      return window.localStorage.getItem(key);
    } catch(e) {
      return null;
    }
  }

  public static delete(key: string): void {
    if (!this.isSupported()) {
      return;
    }

    try {
      window.localStorage.removeItem(key);
    } catch(e) {
      return;
    }
  }
}
